import { render, staticRenderFns } from "./MealSpecModal.vue?vue&type=template&id=08082101&scoped=true"
import script from "./MealSpecModal.vue?vue&type=script&lang=js"
export * from "./MealSpecModal.vue?vue&type=script&lang=js"
import style0 from "./MealSpecModal.vue?vue&type=style&index=0&id=08082101&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08082101",
  null
  
)

export default component.exports